<template>
  <el-config-provider :locale="zhCn">
    <div class="router-view-wrapper">
      <router-view />
    </div>
    <DownloadProgressFloat />
    <div v-if="showCopyright" class="global-copyright">copyright@长沙寻众科技有限公司</div>
  </el-config-provider>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import DownloadProgressFloat from '@/components/DownloadProgressFloat.vue'

export default {
  name: 'App',
  components: { DownloadProgressFloat },
  setup() {
    const route = useRoute()
    const showCopyright = computed(() => {
      const hiddenPrefixes = [
        '/video/storyboard',
        '/script/online',
        '/video/recording/audiobook',
        '/ai-video-dub'
      ]
      const p = route.path || ''
      return !hiddenPrefixes.some(prefix => p === prefix || p.startsWith(prefix + '/'))
    })
    return {
      zhCn,
      showCopyright
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text-primary);
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--color-bg-page);
}

/* 主内容区占满剩余空间，避免总高度超出视口产生右侧滚动条 */
/* Electron 下有时 height:100% 链断裂，用 min-height:100vh 保证登录页等有可视区域，避免白屏 */
.router-view-wrapper {
  flex: 1;
  min-height: 100vh;
  min-height: 100dvh; /* 移动端地址栏变化时更稳定 */
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* 官网首页仍可滚动，但不显示滚动条。由 HomePage 挂载时显式添加该类，避免
   :has() 在旧版 Chromium 或部分 Electron 环境中不生效。 */
html.homepage-scrollbar-hidden,
body.homepage-scrollbar-hidden,
#app:has(.homepage),
.router-view-wrapper.homepage-scrollbar-hidden {
  height: 100dvh !important;
  min-height: 0 !important;
  overflow: hidden !important;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}

html.homepage-scrollbar-hidden::-webkit-scrollbar,
body.homepage-scrollbar-hidden::-webkit-scrollbar,
#app:has(.homepage)::-webkit-scrollbar,
.router-view-wrapper.homepage-scrollbar-hidden::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.global-copyright {
  position: fixed;
  right: 18px;
  bottom: 12px;
  font-size: 13px;
  color: var(--color-text-placeholder);
  z-index: 9999;
  pointer-events: none;
  user-select: none;
  letter-spacing: 1px;
}

/* 手机界面隐藏copyright */
@media (max-width: 768px) {
  .global-copyright {
    display: none !important;
  }
}

/* 只隐藏页面自身的 footer，不影响 Element Plus 弹窗按钮栏。 */
body:has(.video-storyboard-container) footer:not(.el-dialog__footer) {
  display: none !important;
}

/* 在线画本页面隐藏 footer 备案信息 */
body:has(.script-online) footer:not(.el-dialog__footer) {
  display: none !important;
}

/* AI视频配音页面隐藏 footer 备案信息和 copyright */
body:has(.ai-video-dub-container) .global-copyright,
body:has(.ai-video-dub-container) footer:not(.el-dialog__footer) {
  display: none !important;
}

/* 有声在线录音页面隐藏 footer 备案信息（ICP/公安备案/Copyright） */
body:has(.audiobook-recording-page) footer:not(.el-dialog__footer) {
  display: none !important;
}

/* 分镜分享页使用 public/index.html 的备案栏，隐藏右下角小 copyright，避免盖住正文 */
body:has(.storyboard-share-container) .global-copyright {
  display: none !important;
}

/* 分镜分享页内容可能很长：备案栏改为跟随页面流动，不固定遮挡底部内容 */
body:has(.storyboard-share-container) footer:not(.el-dialog__footer) {
  position: static !important;
  left: auto !important;
  bottom: auto !important;
  z-index: auto !important;
  box-sizing: border-box !important;
  margin-top: 12px !important;
  flex-shrink: 0 !important;
}

/* 全屏模式下下拉菜单的 z-index 修复 */
body:has(.video-tracks-container.fullscreen-mode) .el-select-dropdown,
body:has(.video-tracks-container.fullscreen-mode) .el-popper,
body.video-recording-fullscreen .el-select-dropdown,
body.video-recording-fullscreen .el-popper {
  z-index: 10000 !important;
  visibility: visible !important;
  display: block !important;
  opacity: 1 !important;
  pointer-events: auto !important;
}

/* 确保下拉菜单不被全屏容器裁剪 */
body.video-recording-fullscreen .el-select-dropdown,
body.video-recording-fullscreen .el-popper {
  position: fixed !important;
}

/* ????????????????? */
.el-dialog__footer {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 8px !important;
  padding: 12px 20px !important;
  border-top: 1px solid var(--el-border-color-light, rgba(255,255,255,0.08)) !important;
}
.el-dialog__footer .el-button {
  visibility: visible !important;
  opacity: 1 !important;
}
</style>
